module.exports = __webpack_public_path__ + "static/media/fiscal.04749677.svg";